import React from 'react';
import { Navigate } from 'react-router-dom';

// The old standalone /sms-policy page has been merged into /terms (section 8).
// Kept as a route so any pre-existing Twilio review links keep working.
export default function SmsPolicy() {
  return <Navigate to="/terms#s8" replace />;
}
